module.exports = __webpack_public_path__ + "assets/img/opinionWarning.9bc9bc12.png";